import { MessageCircle } from "lucide-react";
import { waLink, DEFAULT_WA_TEXT } from "../../lib/constants";
import { track } from "../../lib/tracking";

export const StickyBar = () => (
  <div
    data-testid="sticky-mobile-bar"
    className="fixed bottom-0 inset-x-0 z-50 md:hidden border-t border-champagne/50 bg-ivory/95 backdrop-blur-xl px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
  >
    <div className="flex items-center justify-between gap-3">
      <div className="leading-tight">
        <p className="font-display text-2xl font-medium text-teal">₹22,500</p>
        <p className="font-mono text-[0.55rem] uppercase tracking-[0.25em] text-ink/50">Package · Save ₹12,500</p>
      </div>
      <a
        href={waLink(DEFAULT_WA_TEXT)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track("whatsapp_click", { placement: "sticky_bar" })}
        data-testid="sticky-whatsapp-button"
        className="inline-flex items-center gap-2 rounded-full bg-teal px-7 py-3.5 text-xs font-bold uppercase tracking-[0.14em] text-ivory active:bg-teal-800"
      >
        <MessageCircle className="w-4 h-4" strokeWidth={1.8} />
        WhatsApp Now
      </a>
    </div>
  </div>
);
